var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDirectoryIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".userDirectoryIco_svg__a{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1164 -52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "userDirectoryIco_svg__a",
    width: 28,
    height: 28,
    rx: 2,
    transform: "translate(1164 52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "userDirectoryIco_svg__a",
    d: "M1167.5 55.5h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.735 59.192a1.935 1.935 0 00-.158-.3 1.734 1.734 0 00-.472-.473 1.935 1.935 0 00-.3-.158 1.761 1.761 0 00-.68-.136h-.875v-1.75h-1.75v1.75h-7v-1.75h-1.75v1.75h-.875a1.774 1.774 0 00-.98.3 1.735 1.735 0 00-.47.47 1.935 1.935 0 00-.158.3 1.761 1.761 0 00-.142.68v12.25a1.75 1.75 0 001.75 1.75h12.25a1.761 1.761 0 00.683-.14 1.935 1.935 0 00.3-.158 1.735 1.735 0 00.472-.472 1.8 1.8 0 00.3-.98v-12.25a1.761 1.761 0 00-.14-.682zm-13.86 12.933v-12.25h12.25v12.25zm6.125-5.35c-1.776 0-5.25.945-5.25 3.132v1.348h10.5v-1.344c0-2.2-3.474-3.141-5.25-3.141zm-3.229 2.73a6.135 6.135 0 013.229-.98 6.109 6.109 0 013.229.98zm3.229-3.5a2.625 2.625 0 10-2.625-2.63A2.633 2.633 0 001178 66zm0-3.5a.875.875 0 11-.875.87.878.878 0 01.875-.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.25 62.5h-1.75v12.25a1.755 1.755 0 001.75 1.75h12.25v-1.75h-12.25z"
  }))));
}
export default SvgUserDirectoryIco;